export const state = () => ({
    articles: [],
    article: null,
});

export const mutations = {
    setArticles(state, articles) {
        state.articles = articles;
    },
    setArticle(state, article) {
        state.article = article;
    },
};

export const actions = {
    async fetchArticles(context, options) {
        const language = context.getters.getLanguageForLocaleCode(this.$i18n.locale);

        try {
            let { data } = await this.$adminApi.get(`/insight/articles?lang=${language}&limit=${options?.limit ?? ""}`);
            context.commit("setArticles", data.articles ?? data.data);
        } catch (error) {
            console.log("Failed to fetch insight articles: " + error);
            throw error;
        }
    },
    async fetchArticle(context, payload) {
        const language = context.getters.getLanguageForLocaleCode(this.$i18n.locale);

        try {
            let { data } = await this.$adminApi.get(`/insight/article/${payload.year}/${payload.slug}?lang=${language}`);
            context.commit("setArticle", data.article);
        } catch (error) {
            console.log("Failed to fetch insight articles: " + error);
            throw error;
        }
    },
};

export const getters = {
    getArticles(state) {
        return state.articles;
    },
    getFeaturedArticles(state) {
        return state.articles.filter((article) => article.featured);
    },
    getArticle(state) {
        return state.article;
    },
    getCategories(state) {
        return Object.values(
            state.articles.reduce((categories, article) => {
                categories[article.category.id] = article.category;
                return categories;
            }, {})
        );
    },
    getCurrentLanguage(state) {
        if (!state.articles.length) return null;
        return state.articles[0].language_id ?? null;
    },

    /**
     * Maps a locale code to a language code. Useful for
     * some languages in multiple locales.
     */
    getLanguageForLocaleCode() {
        return (code) => {
            switch (code) {
                case "jp":
                    return "en-US";
                case "cn":
                    return "en-US";
                default:
                    return "en-US";
            }
        };
    },

    /**
     * Will return true if no articles are present or if
     * the site language doesn't match the loaded articles' language.
     */
    getShouldLoadInsightArticlesForLocaleCode(state, getters) {
        return (code) => !state.articles.length || (getters.getCurrentLanguage && getters.getCurrentLanguage !== getters.getLanguageForLocaleCode(code));
    },
};
